<div class="cont">
  <router-outlet></router-outlet>
</div>
<app-preview-qr></app-preview-qr>
